import {isEmpty} from "@helpers/helpers";
import {getCityEnName} from "../invest/investment_tracks";

export function handleShowCrmModalTrack(city_id, page) {
    const city_name = getCityEnName(city_id);

    if (!isEmpty(window.dataLayer)) {
        window.dataLayer.push({
            'event': 'invest-request-form-view',
            'event_section': 'properties',
            'event_view': (page === 'on_lists' ? 'list' : 'show'),
            'city_name': city_name,
        });
    }
}

export function handleSubmitTrack(city_id, page, position = '') {
    const city_name = getCityEnName(city_id);

    if (!isEmpty(window.dataLayer)) {
        window.dataLayer.push({
            'event': 'invest-request-form-submit',
            'event_section': 'properties',
            'event_view': (page === 'on_lists' ? 'list' : 'show'),
            'event_position': position,
            'city_name': city_name,
        });
    }
}